import { z } from 'zod/v4';

export const vendorContactEmailSchema = z.email();

// HTML patterns use the v flag, which requires escaping literal hyphens.
export const vendorContactEmailPattern = z.regexes.email.source.replace(/(?<!\\)-(?=\])/g, '\\-');
